import { Box, Divider, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ISeminario } from '../../../services/api/action-plan/Seminario';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';

interface ISummarySeminar {
    data: ISeminario
}

export const SummarySeminar = ({data}: ISummarySeminar) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return(
        <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box>
                <Typography><strong>Informações do último Seminario</strong></Typography>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Data seminário : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_seminario)}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Período de referência : </Typography>
                    <Typography>{formatDateWhitoutHour(data.periodo_referencia)}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>ART : </Typography>
                    <Typography>{data.art}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Responsável técnico : </Typography>
                    <Typography>{data.responsavel_tecnico}</Typography>
                </Box>
                <Divider/>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: '5px', overflowX: 'auto'}} width={'100%'} padding={1}>
                    <Typography><strong>Participantes</strong></Typography>
                    <Table component={Paper} sx={{borderRadius: '25px', borderColor: theme.palette.primary.contrastText, flex: 1}} variant='elevation'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Profissional</TableCell>
                                <TableCell>Empresa</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.participantes?.map((item, index) => 
                                <TableRow key={index}>
                                    <TableCell>{item.profissional}</TableCell>
                                    <TableCell>{item.empresa}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
                <Divider/>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: '5px', overflowX: 'auto'}} width={'100%'} padding={1}>
                    <Typography><strong>Frequentadores</strong></Typography>
                    <Table component={Paper} sx={{borderRadius: '25px', borderColor: theme.palette.primary.contrastText, flex: 1}} variant='elevation'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome</TableCell>
                                <TableCell>Contato</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.frequentadores?.map((item, index) => 
                                <TableRow key={index}>
                                    <TableCell>{item.nome}</TableCell>
                                    <TableCell>{item.contato}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        </Box>
    );
};